import React, { useState } from 'react';
import { Modal, Form, message } from 'antd';
import EmployeeForm from './EmployeeForm';
import apiClient from '../services/api';
import { v4 as uuidv4 } from 'uuid';

interface EmployeeModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: (employee: any) => void;
  companies?: any[];
  isSuperAdmin?: boolean;
  currentUser?: any;
  hideFields?: string[];
}

const EmployeeModal: React.FC<EmployeeModalProps> = ({ 
  visible, 
  onCancel, 
  onSuccess, 
  companies = [], 
  isSuperAdmin = false,
  currentUser,
  hideFields = [],
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values: any) => {
    setLoading(true);
    try {
      const data = {
        ...values,
        company_id: (currentUser?.role === 'company_admin' || currentUser?.role === 'manager') ? currentUser.company_id : Number(values.company_id),
        public_uuid: uuidv4()
      };
      const employee = await apiClient.createEmployee(data);
      message.success('Tạo nhân viên thành công!');
      onSuccess(employee);
      form.resetFields();
    } catch (error) {
      message.error('Tạo nhân viên thất bại!');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Tạo nhân viên mới"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
    >
      <EmployeeForm
        form={form}
        onFinish={handleFinish}
        loading={loading}
        submitText="Tạo mới"
        companies={companies}
        isSuperAdmin={isSuperAdmin}
        currentUser={currentUser}
        hideFields={hideFields}
      />
    </Modal>
  );
};

export default EmployeeModal; 